import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageBasicTemplate from './PageBasicTemplate';
const bookingUrl = 'https://timerex.net/s/g.komaki_005f/475eb7b3';
declare global { interface Window { TimerexCalendar: () => void; } }
export default function InterviewArrangement() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://asset.timerex.net/js/embed.js'; script.async = true; script.id = 'timerex_embed';
    script.onload = () => { window.TimerexCalendar?.(); };
    document.body.appendChild(script);
    return () => { script.onload = null; script.remove(); };
  }, []);
  return <PageBasicTemplate title="カジュアル面談" sub_title="経験や興味、これから取り組みたいこと。まずは気軽にお話ししましょう。"><div className="intro-layout"><h2 className="content-heading">お互いを知る、<br />最初の時間。</h2><p>ご都合のよい日時をカレンダーからお選びください。FRiCTONの仕事やチームについてお話ししながら、あなたの経験とこれからの挑戦をお聞きします。</p></div><div className="booking-box"><div id="timerex_calendar" data-url={bookingUrl} /></div><p className="booking-fallback">カレンダーが表示されない場合は、<a href={bookingUrl} target="_blank" rel="noopener noreferrer">予約ページを開く</a>か、<Link to="/contact?service=その他">お問い合わせ</Link>からご連絡ください。</p></PageBasicTemplate>;
}
